import formatDate from "@DateTime/functions/formatDate";
import React from "react";
import isSlideDisabled from "@SearchResults/features/dateSlick/functions/isSlideDisabled";
import getSlidesClassName from "@SearchResults/features/dateSlick/functions/getSlidesClassName";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import getSlideFunctions from "@SearchResults/features/dateSlick/functions/getSlideFunctions";

interface DateSlickSlideProps {
    date: Date,
    isReturn: boolean,
    searchedDate: string,
    centralDateRef: React.ForwardedRef<HTMLDivElement>,
    selectNewSearchDate: (selectedDate: string) => void
}

function DateSlickSlide(props: DateSlickSlideProps) {
    const {
        date,
        isReturn,
        searchedDate,
        selectNewSearchDate,
        centralDateRef,
    } = props

    const {date: singleLegDate} = useAppSelector((state) => (state.form.urlParams))
    const isDisabled = isSlideDisabled(date, singleLegDate, searchedDate, isReturn)
    const formattedDate = formatDate(date, undefined, true)
    const comparisonDate = formatDate(date, undefined, false)

    const {
        onClick,
    } = getSlideFunctions({isDisabled, formattedDate, selectNewSearchDate})

    return (
        <div
            className={getSlidesClassName(comparisonDate, searchedDate, isDisabled)}
            onClick={onClick}
            ref={comparisonDate === searchedDate ? centralDateRef : null}
        >
            <div className="datestrip__content">
                <span className="datestrip__day">
                    {formatDate(formattedDate, 'eeee', true)}
                </span>
                <span>
                    {formatDate(formattedDate, 'dd MMM', true)}
                </span>
            </div>
        </div>

    )
}

export default DateSlickSlide